import { useState } from 'react'

import { ApiFixedMultiplier } from '../../../../../../api/_legacy/generated-api'
import { Space, Tabs } from '../../../../../../components/core-v2'
import { PORTFOLIO_TYPE } from '../../../../../../constants'
import { formatFees, getInvestmentWeightBasedOnTargetWeight } from '../../../../util'
import { AssetSummaryItem, AssetSummaryWithEconomics, ModelPortfolio } from '../../types'
import { PortfolioAssetList } from './asset-list'
import { PortfolioCharges } from './charges'
import { Details } from './details'

export const PortfolioFullDetails = ({
  allAssetPerformance,
  portfolio
}: {
  allAssetPerformance?: Record<string, AssetSummaryItem[]>
  portfolio?: ModelPortfolio
}) => {
  type TabName = 'details' | 'charges' | 'asset-list'

  const [selectedTab, setSelectedTab] = useState<TabName>('details')

  if (!portfolio || !allAssetPerformance) {
    return (
      <Space px={5} py={6}>
        Loading...
      </Space>
    )
  }
  const oneYearAssetPerfs = allAssetPerformance['1y']

  const assetSummary = (portfolio: ModelPortfolio, oneYearAssetPerfs: AssetSummaryItem[]) => {
    const assets: AssetSummaryWithEconomics[] = []
    const assetsList = portfolio.targetWeights
    for (let x = 0; x < assetsList.length; x++) {
      const apiAsset = assetsList[x].asset
      const { assetId } = apiAsset
      let reqReturn = null
      let reqVol = null
      for (let y = 0; y < oneYearAssetPerfs.length; y++) {
        if (assetId === oneYearAssetPerfs[y].id) {
          reqReturn = oneYearAssetPerfs[y].return
          reqVol = oneYearAssetPerfs[y].volatility
        }
      }
      let fixedMultiplier = null as ApiFixedMultiplier
      switch (apiAsset.multiplier.multiplierType) {
        case 'Fixed':
          fixedMultiplier = apiAsset.multiplier as ApiFixedMultiplier
          break
        case 'Variable':
      }
      const asset: AssetSummaryWithEconomics = {
        id: apiAsset.assetId,
        investment: getInvestmentWeightBasedOnTargetWeight(portfolio, assetsList[x])?.weight,
        name: apiAsset.name,
        maxLevRatio: apiAsset.maxLeverageRatio,
        fixedMultiplier: fixedMultiplier === null ? null : fixedMultiplier.multiplier,
        return: reqReturn,
        volatility: reqVol,
        weight: assetsList[x].weight
      }
      assets.push(asset)
    }
    return assets
  }

  return (
    <>
      <Tabs.List className="mt-4 mx-3">
        <Tabs.Tab
          isSelected={selectedTab === 'details'}
          value="details"
          onClick={() => setSelectedTab('details')}
        >
          Details
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={selectedTab === 'charges'}
          value="charges"
          onClick={() => setSelectedTab('charges')}
        >
          Charges
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={selectedTab === 'asset-list'}
          value="asset-list"
          onClick={() => setSelectedTab('asset-list')}
        >
          Assets
        </Tabs.Tab>
      </Tabs.List>

      {selectedTab === 'details' && (
        <Tabs.Panel value="details">
          <Details portfolio={portfolio} />
        </Tabs.Panel>
      )}

      {selectedTab === 'charges' && (
        <Tabs.Panel value="charges">
          <PortfolioCharges portfolioFees={formatFees(portfolio.fees)} />
        </Tabs.Panel>
      )}

      {selectedTab === 'asset-list' && (
        <Tabs.Panel value="asset-list">
          <PortfolioAssetList
            assets={assetSummary(portfolio, oneYearAssetPerfs)}
            isFundOfFunds={PORTFOLIO_TYPE[portfolio.type].key === 'FundOfFunds'}
          />
        </Tabs.Panel>
      )}
    </>
  )
}
